import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/init/init.module.ts' );

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { InitDBComponent } from './init-db.component';
import { SharedModule } from '../commons/shared.module';
import { InitLicenceComponent } from './init-licence.component';
import { InitComponent } from './init.component';
import { InitAccountComponent } from './init-account.component';


const AppRouting: Routes = [
 
  {
    path: '', component:InitComponent,
    children: [
      { path: '', redirectTo:"db", pathMatch: 'full' },
      { path: "db", component:InitDBComponent, pathMatch: 'full' },
      { path: "licence", component:InitLicenceComponent, pathMatch: 'full' },
      { path: "account", component:InitAccountComponent, pathMatch: 'full' }

]}

];


@NgModule({
  declarations: [InitComponent,InitDBComponent,InitLicenceComponent,InitAccountComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(AppRouting)
  ]
})
export class InitModule { }
